import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import FinancialCustomReportStructure from "../components/FinancialReporting/FinancialCustomReportStructure";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    banner: appState.banner,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateReportType: (reportStructure: KeyValue[]) => {
      dispatch(actions.updateUi("reportType", "customResults"));
      dispatch(actions.updateUi("reportStructure", reportStructure));
    },
    updateGenerateVars: (values: string[]) => {
      dispatch(actions.updateUi("customVariables", values));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialCustomReportStructure);
